import axios from "axios";

const getProductByCompany = async (companyId: string) => {
  try {
    const data = JSON.stringify({
      query: `query{
                  productByCompanyIdAll(companyID: "${companyId}")
                  {
                    _id,
                    name,
                    sku,
                    categoryID,
                    price,
                    buyingPrice {
                        price,
                        quantity
                    },
                    status,
                    quantity,
                    description,
                    companyID,
                    supplierID,
                    picture,
                    packaging,
                    location,
                    options {
                            _id,
                            name,
                            sku,
                            unit,
                            price,
                            description,
                            weight
                        }
                    }
              }`,
      variables: {},
    });

    const config = {
      method: "post",
      url: `/graphql`,
      headers: {
        //   Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
        "Content-Type": "application/json",
      },
      data,
    };

    return await axios(config).then((response) => {
      if (response?.data?.errors?.length > 0) {
        return [];
      }
      // productByCompanyID = response.data.data.productById;
      return response.data.data.productByCompanyIdAll;
    });
  } catch (error) {
    console.log("Error getting product info from getCompany: ", error);
  }
};

export { getProductByCompany };
